// extracted by mini-css-extract-plugin
export var root = "related-pages-module--root--E34zO";
export var listItem = "related-pages-module--listItem--4C3iE";
export var headline = "related-pages-module--headline--QLtQg";
export var grid = "related-pages-module--grid--TGbC5";
export var related_pages = "related-pages-module--related_pages--Idvrs";